import axios from "axios";

export default axios.create({
  baseURL: "https://hash-stitch.onrender.com",
  headers: {
    "Content-Type": "application/json",
  },
});
